import type { FeatureFlagValues } from '@his/feature-flags';
import type { FC } from 'react';

export type DashboardRegistryEntry = {
  role: string;
  load: () => Promise<{ default: FC }>;
};

export type DashboardRegistry = {
  entries: ReadonlyArray<DashboardRegistryEntry>;
  defaultLoad: (() => Promise<{ default: FC }>) | null;
};

const loadDoctorDashboard = () =>
  import('../doctor-dashboard').then(({ default: Component }) => ({
    default: Component,
  }));

const loadNurseDashboard = () =>
  import('../nurse-dashboard').then(({ default: Component }) => ({
    default: Component,
  }));

export const createDashboardRegistry = (
  flags: Pick<FeatureFlagValues, 'doctorDashboardEnabled'>,
): DashboardRegistry => ({
  entries: [
    {
      role: 'doctor',
      load: flags.doctorDashboardEnabled
        ? loadDoctorDashboard
        : loadNurseDashboard,
    },
    { role: 'nurse', load: loadNurseDashboard },
    { role: 'admin', load: loadNurseDashboard },
  ],
  defaultLoad: null,
});
